import { render, staticRenderFns } from "./CaseSimple.vue?vue&type=template&id=5947cf84&"
import script from "./CaseSimple.vue?vue&type=script&lang=js&"
export * from "./CaseSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports